import { SET_APP_CONFIGURATION } from "../action/appConfiguration";

const initialState = {
  footerLinks: [],
};

export default function appConfigurationReducer(state = initialState, action) {
  switch (action.type) {
    case SET_APP_CONFIGURATION: {
      return {
        ...state,
        footerLinks: action.payload.footerLinks || [],
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
